module.exports = __webpack_public_path__ + "img/user.85b22d4d.png";